<div class="container">
<div class="text-center div_titulo">
  <label class="titulo"><p>Completa tus datos para que podamos brindarte un asesoramiento personalizado y adaptado a tus necesidades.</p></label>
    <label class="subtitulo"><p>A partir de esta información, uno de nuestros asesores comerciales se pondrá en contacto con vos para informarte sobre los planes disponibles y ayudarte a elegir la mejor opción.</p></label>
  </div>



  <div class="indicacion-plan">
    <span>Seleccioná una opción para cotizar tu plan:</span>
  </div>

  <div class="botones-flex-group">
    <div class="boton-con-label">
      <button class="boton boton_solo boton-elevado" type="button"  [ngClass]="{'selected': tipoGrupo === 'solo'}" (click)="setGrupo('solo')">
        <span class="boton-etiqueta etiqueta-desktop">Solo yo</span>
      </button>
      <span class="boton-etiqueta etiqueta-mobile">Solo yo</span>
    </div>
    <div class="boton-con-label">
      <button class="boton boton_pareja boton-elevado" type="button" [ngClass]="{'selected': tipoGrupo === 'pareja'}" (click)="setGrupo('pareja')">
        <span class="boton-etiqueta etiqueta-desktop">Mi pareja y yo</span>
      </button>
      <span class="boton-etiqueta etiqueta-mobile">Mi pareja y yo</span>
    </div>
    <div class="boton-con-label">
      <button class="boton boton_hijos boton-elevado" type="button" [ngClass]="{'selected': tipoGrupo === 'hijos'}" (click)="setGrupo('hijos')">
        <span class="boton-etiqueta etiqueta-desktop">Mis hijos y yo</span>
      </button>
      <span class="boton-etiqueta etiqueta-mobile">Mis hijos y yo</span>
    </div>
    <div class="boton-con-label">
      <button class="boton boton_familia boton-elevado" type="button" [ngClass]="{'selected': tipoGrupo === 'familia'}" (click)="setGrupo('familia')">
        <span class="boton-etiqueta etiqueta-desktop">Mi familia y yo</span>
      </button>
      <span class="boton-etiqueta etiqueta-mobile">Mi familia y yo</span>
    </div>
  </div>


  <form *ngIf="tipoGrupo" [formGroup]="formPrepaga" autocomplete="off">

    <div class="nombre-apellido-row">
      <mat-form-field class="nombre-field">
        <mat-label>Nombre</mat-label>
  <input matInput type="text" formControlName="nombre" #inputNombre>
      </mat-form-field>
      <mat-form-field class="apellido-field">
        <mat-label>Apellido</mat-label>
        <input matInput type="text" formControlName="apellido">
      </mat-form-field>
    </div>


    <div class="edades-pareja-row">
      <mat-form-field class="edad-field">
        <mat-label>Mi edad</mat-label>
        <input matInput type="number" formControlName="edad">
      </mat-form-field>

      <mat-form-field class="edad-field" *ngIf="tipoGrupo === 'pareja' || tipoGrupo === 'familia'">
        <mat-label>Edad de mi pareja</mat-label>
        <input matInput type="number" formControlName="edadPareja">
      </mat-form-field>
    </div>

    <mat-form-field class="example-full-width" *ngIf="tipoGrupo === 'hijos' || tipoGrupo === 'familia'">
      <mat-label>Cantidad de hijos</mat-label>
      <mat-select formControlName="cantidadHijos" (selectionChange)="onCantidadHijosChange()">
        <mat-option *ngFor="let n of hijosOptions" [value]="n">{{n}}</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="cantidadHijos > 0" class="edades-hijos-row">
      <div *ngFor="let i of hijosArray; let idx = index" class="edad-hijo-item">
        <mat-form-field>
          <mat-label>Edad {{idx + 1}}</mat-label>
          <input matInput type="number" [formControlName]="'edadHijo' + idx">
        </mat-form-field>
      </div>
    </div>




    <mat-form-field class="example-full-width">
      <mat-label>Localidad</mat-label>
      <input matInput type="text" formControlName="localidad">
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>Provincia</mat-label>
      <mat-select formControlName="provincia">
        <mat-option *ngFor="let p of provincias" [value]="p">{{p}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>Número de documento</mat-label>
      <input matInput formControlName="documento">
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>Relación laboral</mat-label>
      <mat-select formControlName="trabajo">
        <mat-option value="dependencia">Relación de dependencia</mat-option>
        <mat-option value="particular">Particular</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>Teléfono</mat-label>
      <input matInput formControlName="telefono">
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>Correo electrónico</mat-label>
      <input matInput formControlName="email">
    </mat-form-field>

    <div class="text-center">
  <button mat-button class="boton-enviar" [disabled]="!formPrepaga.valid" (click)="enviar()">Enviar</button>

    </div>
  </form>

</div>
